export default {
  // 重复调证确认对话框
  repeatConfirmTitle: "调证重复确认",
  addTotal: "本次共添加",
  addCount:
    "条调证数据，下列数据已加入过调证建议，请确认是否需要继续加入调证？",

  // 表格列名
  addedBy: "添加人",
  addedTime: "添加时间",
  type: "类型",
  address: "地址",

  // 按钮
  cancel: "取 消",
  confirm: "确 定",

  // 调证类型标题
  normalSurvey: "普通调证",
  keySurvey: "重点调证",

  // 调证分类
  exchangeSurvey: "交易所调证",
  exchangeSurveyDesc: "系统可自行匹配交易所调证数据",
  huobiSurvey: "火币平台调证",
  huobiSurveyDesc: "需用户确认",
  huobiTip:
    "由于火币平台于2021年9月24日起停止大陆新用户注册，针对大陆用户和海外用户调证会涉及不同调证渠道，系统已根据当前调证数据特征计算优先调证渠道，若该渠道无调证结果，用户可手动切换其他渠道重新调证。",
  walletSurvey: "钱包调证",
  walletSurveyDesc: "用户需自行选择钱包平台",

  // 表单字段
  surveyPlatform: "调证平台",
  selectPlatform: "请选择调证平台",
  selectOption: "请选择",
  surveyReason: "调证原因",
  inputReason: "请输入调证原因",

  // 提示消息
  selectSurveyData: "请选择需要加入的调证",
  selectWalletPlatform: "请选择钱包调证平台",
  inputReasonRequired: "请输入调证原因",
  addSuccess: "已加入调证",
  successTitle: "成功",

  // 类型标签
  hashType: "哈希",
};
